import React, { useEffect, useState } from 'react';
export const UrgencyBar = () => {
  // 2 hours in seconds
  const [timeLeft, setTimeLeft] = useState(2 * 60 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <div className="sticky top-0 z-50 bg-brown text-gold py-3 px-4 shadow-md w-full" data-id="element-163">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-center text-center text-sm md:text-base font-medium tracking-wide" data-id="element-164">
        <span data-id="element-165">
          OFERTA DE LANZAMIENTO: 70% de descuento disponible solo para las
          próximas 15 unidades o hasta que el contador llegue a cero.
        </span>
        <div className="mt-2 md:mt-0 md:ml-4 flex items-center bg-charcoal/30 px-3 py-1 rounded-sm border border-gold/20" data-id="element-166">
          <span className="font-mono text-lg" data-id="element-167">
            {hours.toString().padStart(2, '0')}:
            {minutes.toString().padStart(2, '0')}:
            {seconds.toString().padStart(2, '0')}
          </span>
        </div>
      </div>
    </div>;
};